(function ($) {
    // Lightbox depends on Magnific Popup.
    if (typeof $.fn.magnificPopup !== 'function') {
        return;
    }

    $(function () {
        // Add lightbox gallery effect.
        $('.js-lightbox-gallery').magnificPopup({
            delegate: 'a.js-lightbox',
            type: 'image',
            gallery: {
                enabled: true
            }
        });

        // Add individual lightbox effect to links outside galleries.
        $('.js-lightbox').each(function (itemIndex, itemNode) {
            var item = $(itemNode);
            var gallery = item.parents('.js-lightbox-gallery');

            if (gallery.length !== 0) {
                return;
            }

            item.magnificPopup({
                type: 'image'
            });
        });
    });
})(jQuery);

(function ($) {
    // Lightbox depends on Magnific Popup.
    if (typeof $.fn.magnificPopup !== 'function') {
        return;
    }

    $(function () {
        // Add lightbox gallery effect.
        $('.woocommerce-product-gallery__image').magnificPopup({
            delegate: '> a',
            type: 'image',
            gallery: {
                enabled: true
            }
        });
    });
})(jQuery);
